import React from 'react';
import { useNavigate } from 'react-router-dom';
import BrandHeader from '../login-screen/components/BrandHeader';
import LoginForm from '../login-screen/components/LoginForm';
import BackgroundPattern from '../login-screen/components/BackgroundPattern';

const ForgotPasswordScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <BackgroundPattern />
      <div className="relative z-10 min-h-screen flex flex-col">
        <div className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-md">
            <BrandHeader />
            <LoginForm mode="forgot-password" />
          </div>
        </div>
        
        {/* Footer */}
        <div className="py-6 text-center">
          <p className="text-xs text-muted-foreground font-caption">
            © 2024 Major High Academy. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
